import { getPermissionsData } from '../../../apis/rbac';

export default {
  methods: {
    async permissionsList(servicesList, modulesList) {
      const permissionsList = [];
      const services = await getPermissionsData();
      services.filter((service) => { // service
        if (service !== null && servicesList.includes(service.key) && service.access) {
          service.modules.filter((module) => {
            if (module !== null && modulesList.includes(module.key) && module.access) {
              permissionsList.push(module.key);
              module.operations.filter((operation) => { // operation
                if (operation !== null && operation.access) {
                  permissionsList.push(operation.key);
                }
                return true;
              });
            }
            return true;
          });
        }
        return true;
      });
      return permissionsList;
    },
  },
};
